// extracted by mini-css-extract-plugin
export var mark = "highlighted-text-module--mark--7e4f7";